// All site copy, organized per language.
// Languages: fr (default), en, zh
export const translations = {
  fr: {
    code: "fr",
    label: "Français",
    short: "FR",

    nav: {
      about: "À propos",
      services: "Services",
      products: "Produits",
      process: "Processus",
      partners: "Partenaires",
      testimonials: "Témoignages",
      cta: "Devis gratuit",
      openMenu: "Ouvrir le menu",
      ariaMain: "Navigation principale",
      langSwitcher: "Changer la langue",
    },

    hero: {
      overline: "Import multi-sectoriel · Depuis 2008",
      title1: "Le monde,",
      title2: "livré à votre",
      title3: "porte.",
      subtitle:
        "Sourcing international, logistique multimodale, dédouanement et distribution. klairys orchestre votre chaîne d'importation de bout en bout — sur tous les continents, dans tous les secteurs.",
      ctaQuote: "Demander un devis",
      ctaServices: "Découvrir nos services",
      scroll: "Faire défiler",
      stats: [
        { num: "62", label: "Pays sourcés" },
        { num: "12k+", label: "Conteneurs / an" },
        { num: "98.4%", label: "Livraison à temps" },
        { num: "16 ans", label: "D'expertise terrain" },
      ],
    },

    about: {
      overline: "À propos",
      title1: "Une expertise patiemment construite,",
      title2: "une exécution résolument moderne.",
      body:
        "Depuis 16 ans, klairys accompagne PME, ETI et groupes industriels dans leurs flux d'importation multi-sectoriels. Notre promesse : simplifier la complexité du commerce international, en assumant la responsabilité totale de la chaîne — de l'usine à votre quai.",
      values: [
        {
          title: "Conformité absolue",
          desc: "Maîtrise complète des incoterms, normes douanières et certifications produits sur 60+ marchés.",
        },
        {
          title: "Sourcing intelligent",
          desc: "Réseau direct de fournisseurs audités en Asie, Europe et Amériques — sans intermédiaire.",
        },
        {
          title: "Suivi temps réel",
          desc: "Plateforme de tracking dédiée, alertes douanières et reporting hebdomadaire transparent.",
        },
      ],
      statLabel: "En activité",
      statNum: "420+",
      statBody: "Clients actifs sur 4 continents, fidélisés depuis plus de 5 ans.",
    },

    services: {
      overline: "Services",
      title: "Une offre intégrée, du quai départ au quai d'arrivée.",
      subtitle:
        "Pas de prestataires fragmentés, pas de zones grises : klairys prend en charge chaque maillon, avec un",
      subtitleBold: "interlocuteur unique",
      subtitleEnd: "pour piloter votre flux d'import.",
      items: [
        {
          title: "Sourcing & négociation",
          desc: "Identification de fournisseurs audités, négociation tarifaire et pilotage RFQ pour optimiser vos coûts d'achat.",
        },
        {
          title: "Logistique multimodale",
          desc: "Maritime, aérien, routier, ferroviaire — nous orchestrons le mode optimal selon coût, délai et empreinte carbone.",
        },
        {
          title: "Dédouanement",
          desc: "Représentation en douane, classement tarifaire, gestion des licences d'importation et conformité réglementaire.",
        },
        {
          title: "Distribution finale",
          desc: "Livraison hub-to-door en France et UE, cross-docking, picking, label & repack à la demande.",
        },
        {
          title: "Contrôle qualité",
          desc: "Inspections pré-expédition, tests laboratoire et audits usine sur 60+ marchés sourcés.",
        },
        {
          title: "Reporting & analytics",
          desc: "Tableaux de bord temps réel, KPI de chaîne d'approvisionnement, alertes opérationnelles automatisées.",
        },
      ],
      ctaWide: "Demander une démo",
    },

    products: {
      overline: "Produits",
      title1: "Six secteurs maîtrisés.",
      title2: "Une mécanique d'import unique.",
      items: [
        {
          name: "Agro-alimentaire",
          desc: "Épicerie fine, fruits secs, boissons, ingrédients industriels.",
        },
        {
          name: "Textile & mode",
          desc: "Prêt-à-porter, accessoires, linge de maison, marques privées.",
        },
        {
          name: "Électronique",
          desc: "Composants, gadgets, accessoires connectés, IoT industriel.",
        },
        {
          name: "Industrie & outillage",
          desc: "Machines, pièces détachées, EPI, fournitures B2B.",
        },
        {
          name: "Cosmétique & bien-être",
          desc: "Soins, parfumerie, marques niche, conditionnement à façon.",
        },
        {
          name: "Maison & décoration",
          desc: "Mobilier, art de la table, luminaires, textiles d'intérieur.",
        },
      ],
      itemCta: "Discuter d'un projet",
      banner: "Votre produit n'est pas listé ?",
      bannerSub:
        "Nous référençons un nouveau secteur tous les trimestres. Parlons-en.",
      bannerCta: "Démarrer une discussion",
    },

    process: {
      overline: "Processus",
      title1: "Six étapes,",
      title2: "zéro angle mort.",
      bodyPart1: "Un protocole d'importation éprouvé sur plus de",
      bodyBold: "12 000 conteneurs",
      bodyPart2:
        ". Chaque étape est documentée, traçable et validée par un chef de projet dédié.",
      stepLabel: "ÉTAPE",
      steps: [
        {
          title: "Cadrage du besoin",
          desc:
            "Brief produit, volumes, contraintes réglementaires, objectifs de coût et de délai. Nous co-construisons votre cahier des charges.",
        },
        {
          title: "Sourcing & RFQ",
          desc:
            "Identification de 3 à 5 fournisseurs qualifiés, négociation tarifaire, échantillons et tests qualité.",
        },
        {
          title: "Contractualisation",
          desc:
            "Bon de commande, incoterm optimal, conditions de paiement sécurisées (LC, escrow), planification de production.",
        },
        {
          title: "Production & expédition",
          desc:
            "Suivi production en usine, inspection pré-expédition, consolidation et expédition multimodale.",
        },
        {
          title: "Dédouanement",
          desc:
            "Représentation en douane, déclaration, paiement des droits & taxes, gestion des contrôles sanitaires si requis.",
        },
        {
          title: "Livraison & SAV",
          desc:
            "Distribution finale, déchargement, reporting de cycle. Garantie et suivi qualité post-livraison.",
        },
      ],
    },

    partners: {
      overline: "Partenaires",
      title: "Un réseau d'acteurs majeurs du fret mondial.",
      body:
        "Accords-cadres avec les principaux armateurs et logisticiens internationaux pour garantir capacité, prix et fiabilité.",
    },

    testimonials: {
      overline: "Témoignages",
      title1: "Ils nous confient",
      title2: "leurs flux critiques.",
      items: [
        {
          quote:
            "klairys a refondu notre chaîne d'approvisionnement asiatique en 4 mois. Résultat : -18% de coûts logistiques, +12 jours de marge sur nos délais clients. Une équipe rigoureuse, taillée pour l'opérationnel.",
          name: "Antoine Lefèvre",
          role: "Directeur Achats",
          company: "Manufacture du Nord",
        },
        {
          quote:
            "Nous importons depuis 8 pays. klairys est le seul prestataire qui nous offre un interlocuteur unique et un reporting réellement actionnable. Recommandé sans réserve.",
          name: "Sophie Vasseur",
          role: "Supply Chain Manager",
          company: "Mode Atelier Paris",
        },
        {
          quote:
            "Le dédouanement de matériel sensible était notre point faible. Depuis 3 ans, zéro retard, zéro non-conformité. La maîtrise réglementaire de l'équipe est exceptionnelle.",
          name: "Karim Boudiaf",
          role: "CEO",
          company: "Tekvia Industries",
        },
      ],
      prevAria: "Témoignage précédent",
      nextAria: "Témoignage suivant",
      dotAria: "Voir témoignage",
    },

    contact: {
      overline: "Contact",
      title: "Discutons de votre prochain flux d'import.",
      body:
        "Brief en 15 minutes, devis sous 48h. Pas de jargon, juste une feuille de route claire.",
      emailLabel: "Email",
      sectors: [
        "Agro-alimentaire",
        "Textile & mode",
        "Électronique",
        "Industrie & outillage",
        "Cosmétique & bien-être",
        "Maison & décoration",
        "Autre / multi-secteurs",
      ],
      form: {
        name: "Nom complet *",
        company: "Entreprise",
        email: "Email *",
        phone: "Téléphone",
        sector: "Secteur d'activité",
        sectorPlaceholder: "Choisir un secteur",
        message: "Votre projet *",
        namePh: "Jean Dupont",
        companyPh: "Acme SAS",
        emailPh: "vous@entreprise.com",
        phonePh: "+33 ...",
        messagePh: "Volumes envisagés, pays cibles, contraintes…",
        submit: "Envoyer ma demande",
        sending: "Envoi en cours…",
        legal:
          "En soumettant ce formulaire, vous acceptez d'être recontacté. Aucune donnée n'est partagée à des tiers.",
        errorRequired: "Veuillez remplir les champs obligatoires.",
        success: "Message envoyé. Nous revenons vers vous sous 24h.",
        successTitle: "Message bien reçu, merci.",
        successBody:
          "Un consultant import vous recontacte sous 24h ouvrées avec un cadrage personnalisé.",
        successAgain: "Envoyer un autre message",
      },
    },

    footer: {
      description:
        "Spécialiste de l'importation multi-sectorielle. Sourcing, logistique, dédouanement et distribution clé-en-main pour PME, ETI et groupes industriels.",
      colCompany: "Société",
      colResources: "Ressources",
      colContact: "Contact",
      links: {
        about: "À propos",
        services: "Services",
        process: "Processus",
        careers: "Carrières",
        testimonials: "Témoignages",
        partners: "Partenaires",
        blog: "Blog (bientôt)",
        faq: "FAQ",
        linkedin: "LinkedIn",
        quoteCta: "Demander un devis",
      },
      rights: "Tous droits réservés.",
      legal: "Mentions légales",
      privacy: "Confidentialité",
      tos: "CGV",
    },
  },

  en: {
    code: "en",
    label: "English",
    short: "EN",

    nav: {
      about: "About",
      services: "Services",
      products: "Products",
      process: "Process",
      partners: "Partners",
      testimonials: "Testimonials",
      cta: "Free quote",
      openMenu: "Open menu",
      ariaMain: "Main navigation",
      langSwitcher: "Change language",
    },

    hero: {
      overline: "Multi-sector import · Since 2008",
      title1: "The world,",
      title2: "delivered to your",
      title3: "doorstep.",
      subtitle:
        "Global sourcing, multimodal logistics, customs clearance and distribution. klairys orchestrates your import chain end-to-end — across every continent, every sector.",
      ctaQuote: "Request a quote",
      ctaServices: "Discover our services",
      scroll: "Scroll",
      stats: [
        { num: "62", label: "Sourcing countries" },
        { num: "12k+", label: "Containers / year" },
        { num: "98.4%", label: "On-time delivery" },
        { num: "16 yrs", label: "Field expertise" },
      ],
    },

    about: {
      overline: "About",
      title1: "Expertise patiently built,",
      title2: "execution unapologetically modern.",
      body:
        "For 16 years, klairys has supported SMEs, mid-caps and industrial groups across multi-sector import flows. Our promise: simplify the complexity of international trade, owning the entire chain — from factory floor to your dock.",
      values: [
        {
          title: "Absolute compliance",
          desc: "Full mastery of incoterms, customs standards and product certifications across 60+ markets.",
        },
        {
          title: "Smart sourcing",
          desc: "Direct network of audited suppliers in Asia, Europe and the Americas — no middlemen.",
        },
        {
          title: "Real-time tracking",
          desc: "Dedicated tracking platform, customs alerts and transparent weekly reporting.",
        },
      ],
      statLabel: "Live operations",
      statNum: "420+",
      statBody: "Active clients across 4 continents, retained for 5+ years.",
    },

    services: {
      overline: "Services",
      title: "An integrated offer, from departure dock to arrival dock.",
      subtitle:
        "No fragmented vendors, no grey zones: klairys handles every link, with a",
      subtitleBold: "single point of contact",
      subtitleEnd: "to drive your import flow.",
      items: [
        {
          title: "Sourcing & negotiation",
          desc: "Audited supplier identification, price negotiation and RFQ management to optimize purchasing costs.",
        },
        {
          title: "Multimodal logistics",
          desc: "Sea, air, road, rail — we orchestrate the optimal mode based on cost, time and carbon footprint.",
        },
        {
          title: "Customs clearance",
          desc: "Customs representation, tariff classification, import licenses and regulatory compliance.",
        },
        {
          title: "Final distribution",
          desc: "Hub-to-door delivery in France and EU, cross-docking, picking, label & repack on demand.",
        },
        {
          title: "Quality control",
          desc: "Pre-shipment inspections, lab tests and factory audits across 60+ sourcing markets.",
        },
        {
          title: "Reporting & analytics",
          desc: "Real-time dashboards, supply-chain KPIs, automated operational alerts.",
        },
      ],
      ctaWide: "Request a demo",
    },

    products: {
      overline: "Products",
      title1: "Six mastered sectors.",
      title2: "One unified import engine.",
      items: [
        {
          name: "Food & beverage",
          desc: "Fine groceries, dried fruits, beverages, industrial ingredients.",
        },
        {
          name: "Textile & fashion",
          desc: "Apparel, accessories, home linen, private labels.",
        },
        {
          name: "Electronics",
          desc: "Components, gadgets, connected accessories, industrial IoT.",
        },
        {
          name: "Industry & tooling",
          desc: "Machines, spare parts, PPE, B2B supplies.",
        },
        {
          name: "Cosmetics & wellness",
          desc: "Skincare, fragrance, niche brands, contract packaging.",
        },
        {
          name: "Home & decor",
          desc: "Furniture, tableware, lighting, interior textiles.",
        },
      ],
      itemCta: "Discuss a project",
      banner: "Your product isn't listed?",
      bannerSub: "We onboard a new sector every quarter. Let's talk.",
      bannerCta: "Start a conversation",
    },

    process: {
      overline: "Process",
      title1: "Six steps,",
      title2: "zero blind spots.",
      bodyPart1: "An import protocol proven across more than",
      bodyBold: "12,000 containers",
      bodyPart2:
        ". Every step is documented, traceable and validated by a dedicated project manager.",
      stepLabel: "STEP",
      steps: [
        {
          title: "Needs scoping",
          desc:
            "Product brief, volumes, regulatory constraints, cost & timing targets. We co-design your specs.",
        },
        {
          title: "Sourcing & RFQ",
          desc:
            "Shortlist of 3-5 qualified suppliers, price negotiation, samples and quality testing.",
        },
        {
          title: "Contracting",
          desc:
            "Purchase order, optimal incoterm, secured payment terms (LC, escrow), production planning.",
        },
        {
          title: "Production & shipping",
          desc:
            "On-site production tracking, pre-shipment inspection, consolidation and multimodal shipping.",
        },
        {
          title: "Customs clearance",
          desc:
            "Customs representation, declaration, duties & taxes payment, sanitary controls if required.",
        },
        {
          title: "Delivery & support",
          desc:
            "Final distribution, unloading, cycle reporting. Warranty and post-delivery quality follow-up.",
        },
      ],
    },

    partners: {
      overline: "Partners",
      title: "A network of major global freight players.",
      body:
        "Master agreements with leading international carriers and logistics providers to guarantee capacity, pricing and reliability.",
    },

    testimonials: {
      overline: "Testimonials",
      title1: "They trust us with",
      title2: "their critical flows.",
      items: [
        {
          quote:
            "klairys rebuilt our Asian supply chain in 4 months. Result: -18% logistics cost, +12 days of margin on customer lead times. A rigorous team, built for execution.",
          name: "Antoine Lefèvre",
          role: "Head of Procurement",
          company: "Manufacture du Nord",
        },
        {
          quote:
            "We import from 8 countries. klairys is the only provider giving us a single point of contact and truly actionable reporting. Recommended without reserve.",
          name: "Sophie Vasseur",
          role: "Supply Chain Manager",
          company: "Mode Atelier Paris",
        },
        {
          quote:
            "Customs clearance for sensitive equipment was our weak spot. For 3 years now: zero delay, zero non-compliance. Their regulatory mastery is exceptional.",
          name: "Karim Boudiaf",
          role: "CEO",
          company: "Tekvia Industries",
        },
      ],
      prevAria: "Previous testimonial",
      nextAria: "Next testimonial",
      dotAria: "View testimonial",
    },

    contact: {
      overline: "Contact",
      title: "Let's discuss your next import flow.",
      body:
        "15-minute brief, quote within 48h. No jargon, just a clear roadmap.",
      emailLabel: "Email",
      sectors: [
        "Food & beverage",
        "Textile & fashion",
        "Electronics",
        "Industry & tooling",
        "Cosmetics & wellness",
        "Home & decor",
        "Other / multi-sector",
      ],
      form: {
        name: "Full name *",
        company: "Company",
        email: "Email *",
        phone: "Phone",
        sector: "Sector",
        sectorPlaceholder: "Choose a sector",
        message: "Your project *",
        namePh: "John Doe",
        companyPh: "Acme Inc.",
        emailPh: "you@company.com",
        phonePh: "+33 ...",
        messagePh: "Estimated volumes, target countries, constraints…",
        submit: "Send my request",
        sending: "Sending…",
        legal:
          "By submitting this form you agree to be contacted. No data is shared with third parties.",
        errorRequired: "Please fill the required fields.",
        success: "Message sent. We'll reply within 24 hours.",
        successTitle: "Message received, thank you.",
        successBody:
          "An import consultant will reach out within 24 business hours with a personalized scope.",
        successAgain: "Send another message",
      },
    },

    footer: {
      description:
        "Specialist in multi-sector imports. Sourcing, logistics, customs clearance and turnkey distribution for SMEs, mid-caps and industrial groups.",
      colCompany: "Company",
      colResources: "Resources",
      colContact: "Contact",
      links: {
        about: "About",
        services: "Services",
        process: "Process",
        careers: "Careers",
        testimonials: "Testimonials",
        partners: "Partners",
        blog: "Blog (soon)",
        faq: "FAQ",
        linkedin: "LinkedIn",
        quoteCta: "Request a quote",
      },
      rights: "All rights reserved.",
      legal: "Legal notice",
      privacy: "Privacy",
      tos: "Terms",
    },
  },

  zh: {
    code: "zh",
    label: "中文",
    short: "中文",

    nav: {
      about: "关于我们",
      services: "服务方案",
      products: "产品类目",
      process: "服务流程",
      partners: "合作伙伴",
      testimonials: "客户案例",
      cta: "免费询价",
      openMenu: "打开菜单",
      ariaMain: "主导航",
      langSwitcher: "切换语言",
    },

    hero: {
      overline: "多行业进口贸易 · 始创于 2008 年",
      title1: "全球货源,",
      title2: "直达您的",
      title3: "门口。",
      subtitle:
        "全球寻源、多式联运、清关报关与末端配送。klairys 为您全程托管进口供应链——覆盖六大洲,深耕各行各业。",
      ctaQuote: "申请报价",
      ctaServices: "了解服务方案",
      scroll: "向下滚动",
      stats: [
        { num: "62", label: "采购国家与地区" },
        { num: "12k+", label: "年发集装箱量" },
        { num: "98.4%", label: "准班达成率" },
        { num: "16 年", label: "行业深耕经验" },
      ],
    },

    about: {
      overline: "关于我们",
      title1: "深厚积淀的专业能力,",
      title2: "与时俱进的执行体系。",
      body:
        "16 年来,klairys 始终为中小企业、大中型企业及工业集团提供多行业进口流程支持。我们的承诺:化繁为简,统揽从工厂到您仓库的全链条责任。",
      values: [
        {
          title: "全面合规",
          desc: "精通国际贸易术语解释通则、各国海关法规及 60+ 市场的产品认证体系。",
        },
        {
          title: "高效寻源",
          desc: "直连亚、欧、美三洲经严格审核的优质供应商网络,杜绝中间环节。",
        },
        {
          title: "实时追踪",
          desc: "专属追踪平台、海关动态预警及透明的周度运营报告。",
        },
      ],
      statLabel: "在运项目",
      statNum: "420+",
      statBody: "覆盖四大洲的长期合作客户,平均合作年限超过 5 年。",
    },

    services: {
      overline: "服务方案",
      title: "一体化服务,从起运港到目的港。",
      subtitle:
        "告别分散外包,杜绝服务盲区:klairys 把控每一个环节,以",
      subtitleBold: "单一对接窗口",
      subtitleEnd: "全程统筹您的进口业务。",
      items: [
        {
          title: "寻源与谈判",
          desc: "供应商审核、价格谈判及询价 (RFQ) 管理,助您优化采购成本。",
        },
        {
          title: "多式联运",
          desc: "海运、空运、陆运、铁运——综合成本、时效与碳排放,匹配最优运输方案。",
        },
        {
          title: "进口清关",
          desc: "海关代理、HS 编码归类、进口许可证申办及法规合规咨询。",
        },
        {
          title: "末端交付",
          desc: "法国及欧盟境内门到门配送,提供越库、拣货、贴标及定制重新包装服务。",
        },
        {
          title: "质量管控",
          desc: "装运前检验 (PSI)、实验室检测及覆盖 60+ 采购市场的工厂审核。",
        },
        {
          title: "报表与数据分析",
          desc: "实时数据看板、供应链 KPI 监控、自动化运营预警。",
        },
      ],
      ctaWide: "预约演示",
    },

    products: {
      overline: "产品类目",
      title1: "深耕六大行业,",
      title2: "共享一套进口运作体系。",
      items: [
        {
          name: "食品与饮料",
          desc: "精品食材、干果坚果、饮料、工业原辅料。",
        },
        {
          name: "纺织与服饰",
          desc: "成衣、服饰配件、家纺布艺、自有品牌定制。",
        },
        {
          name: "电子产品",
          desc: "电子元器件、数码配件、智能穿戴、工业物联网。",
        },
        {
          name: "工业与机械",
          desc: "机械设备、备品备件、劳保用品 (PPE)、B2B 工业物资。",
        },
        {
          name: "美妆与健康",
          desc: "护肤、香水、小众品牌、OEM/ODM 代工包装。",
        },
        {
          name: "家居与家饰",
          desc: "家具、餐具、灯具、室内纺织品。",
        },
      ],
      itemCta: "洽谈项目",
      banner: "未找到您的产品类目?",
      bannerSub: "我们每季度新增一个细分行业,欢迎与我们联系。",
      bannerCta: "立即沟通",
    },

    process: {
      overline: "服务流程",
      title1: "六步流程,",
      title2: "全程无盲区。",
      bodyPart1: "经过验证的进口管理流程,已成功承运超过",
      bodyBold: "12,000 个集装箱",
      bodyPart2: "。每一步均有文档记录、可追溯,并由专属项目经理全程负责。",
      stepLabel: "步骤",
      steps: [
        {
          title: "需求评估",
          desc:
            "产品需求、采购量、合规要求及成本与时效目标——共同制定项目方案。",
        },
        {
          title: "寻源与询价",
          desc:
            "筛选 3-5 家合格供应商,完成议价、样品确认与品质测试。",
        },
        {
          title: "合同签订",
          desc:
            "采购订单、最优贸易术语、安全支付方式(L/C 信用证、第三方托管)、生产排期。",
        },
        {
          title: "生产与装运",
          desc:
            "工厂驻厂跟单、装运前检验 (PSI)、拼箱与多式联运。",
        },
        {
          title: "进口清关",
          desc:
            "海关代理、报关申报、关税及税费缴纳;如有需要,办理动植物检验检疫。",
        },
        {
          title: "交付与售后",
          desc:
            "末端配送、卸货交接、项目结算报告;并提供质保期内的售后跟踪服务。",
        },
      ],
    },

    partners: {
      overline: "合作伙伴",
      title: "汇聚全球货运行业核心力量的合作网络。",
      body:
        "与全球主要班轮公司及国际物流商签订年度框架协议,保障运力、价格与服务可靠性。",
    },

    testimonials: {
      overline: "客户案例",
      title1: "他们将关键供应链",
      title2: "托付于 klairys。",
      items: [
        {
          quote:
            "klairys 用 4 个月时间重塑了我们的亚洲供应链。成果:物流成本下降 18%,客户交期富余增加 12 天。一支严谨且执行力极强的团队。",
          name: "Antoine Lefèvre",
          role: "采购总监",
          company: "Manufacture du Nord",
        },
        {
          quote:
            "我们的采购覆盖 8 个国家。klairys 是唯一能提供单点对接与真正可落地报告的服务商。毫无保留地推荐。",
          name: "Sophie Vasseur",
          role: "供应链经理",
          company: "Mode Atelier Paris",
        },
        {
          quote:
            "敏感设备的清关曾是我们的薄弱环节。合作三年至今,零延误、零违规。其合规管控能力堪称卓越。",
          name: "Karim Boudiaf",
          role: "首席执行官",
          company: "Tekvia Industries",
        },
      ],
      prevAria: "上一条评价",
      nextAria: "下一条评价",
      dotAria: "查看评价",
    },

    contact: {
      overline: "联系我们",
      title: "聊聊您下一个进口项目。",
      body: "15 分钟需求沟通,48 小时内出具报价——拒绝套话,只交付清晰可执行的路线图。",
      emailLabel: "电子邮箱",
      sectors: [
        "食品与饮料",
        "纺织与服饰",
        "电子产品",
        "工业与机械",
        "美妆与健康",
        "家居与家饰",
        "其他 / 多行业",
      ],
      form: {
        name: "姓名 *",
        company: "公司名称",
        email: "公司邮箱 *",
        phone: "联系电话",
        sector: "所属行业",
        sectorPlaceholder: "请选择行业",
        message: "项目简介 *",
        namePh: "张三",
        companyPh: "示例公司",
        emailPh: "you@company.com",
        phonePh: "+86 ...",
        messagePh: "预计采购量、目标国家、合规要求…",
        submit: "提交需求",
        sending: "提交中…",
        legal: "提交即表示您同意我们与您联系。我们承诺不会向任何第三方共享您的数据。",
        errorRequired: "请填写所有必填项。",
        success: "已收到您的需求,我们将在 24 小时内回复。",
        successTitle: "需求已成功提交,感谢您的信任。",
        successBody:
          "我们的进口顾问将在 24 个工作小时内与您联系,并提供量身定制的项目方案。",
        successAgain: "再次提交需求",
      },
    },

    footer: {
      description:
        "多行业进口贸易专家。为中小企业、大中型企业及工业集团提供寻源、物流、清关与一站式配送服务。",
      colCompany: "关于公司",
      colResources: "更多资源",
      colContact: "联系我们",
      links: {
        about: "关于我们",
        services: "服务方案",
        process: "服务流程",
        careers: "加入我们",
        testimonials: "客户案例",
        partners: "合作伙伴",
        blog: "博客 (即将上线)",
        faq: "常见问题",
        linkedin: "领英 LinkedIn",
        quoteCta: "申请报价",
      },
      rights: "保留所有权利。",
      legal: "法律声明",
      privacy: "隐私政策",
      tos: "服务条款",
    },
  },
};

export const LANGS = ["fr", "en", "zh"];
